import { NgModule } from '@angular/core';
import { CheckinSearchResultStoreService } from './checkin-search-result-store.service';

@NgModule({
  providers: [CheckinSearchResultStoreService],
})
export class CheckinSearchResultStoreModule {}
